<template>
  <v-dialog
    v-model="show"
    max-width="400"
    overlay-color="darktext"
    overlay-opacity="0.6"
  >
    <v-card>
      <v-card-title class="no-break">
        {{ cdTitle }}
      </v-card-title>
      <v-card-subtitle class="py-4">
        {{ cdText }}
      </v-card-subtitle>
      <v-card-text >

        
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn(title)"
          @submit.prevent
        >
          <v-text-field
            v-model="title"
            data-testid="dialog-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2 pt-4"
            :placeholder="cdInputPlaceholder"
            :rules="titleRules"
          />
          <v-card-actions>
            <v-spacer />
            <v-btn
              ref="cancel"
              data-testid="cancel-button"
              color="darktext"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              @click="show=false"
            >
              {{ cdCancelBtn }}
            </v-btn>
            <v-btn
              ref="submit"
              data-testid="submit-button"
              type="submit"
              color="accent"
              min-width="100"
              dark
              elevation="0"
              class="rounded-xxl text-none px-4"
              :loading="loading"
              @click="Object.keys(item).length > 0 ? edit(title) : submitDialogBtn(title)"
            >
              {{ cdSubmitBtn }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired, ruleValidMin2Max70Characters } from '../rules/formRules.js';
import i18n from '../plugins/i18n';

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdText: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t('submit')
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('cancel')
    },
    cdInputPlaceholder: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({})
    },
    action: {
      type: String,
      default: ''
    },
  },
  data(){
        return{
          valid: true,
          titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
          title: '',
          alertMsg: '',
          loading: false
         }
    },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
          this.$refs.form.reset()
        }
      }
    }
  },
  created(){
    if(Object.keys(this.item).length > 0){
      if(this.action == 'duplicate'){
        this.title = '(' + i18n.t('copy') + ') ' + this.item.attributes.title
      }else {
        this.title = this.item.attributes.title
      }
    }
  },
  methods: {
    submitDialogBtn(title) {
      this.valid = this.$refs.form.validate()
      if(this.valid){
        this.loading = true
        this.$emit('proceedSubmit',title)
      }
    },
    async edit(title){
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.loading = true
        if(this.action == 'duplicate'){
          this.$emit("duplicate",title);
        }else {
          this.$emit("edit",title);
        }
      }
    },
  },
}
</script>